<template>
  <v-dialog :value="visiblePopup" max-width="500px" @input="onDialogInput">
    <v-card>
      <v-card-title>
        <span class="headline">{{ $t('add.new.profile.popup.title') }}</span>
      </v-card-title>
      <v-card-text>
        <div v-if="!isLimitReached">
          <v-text-field
            v-model="profile"
            :label="$t('add.new.profile.popup.input.label')"
            :error-messages="urlValidation.isValid ? '' : urlValidation.message"
            required
            @keyup.enter="saveProfile"
            @keyup.esc="closeAddProfilePopup"
            ref="profileInput"
            class="add-profile-popup-field"
          ></v-text-field>
          <div v-if="urlValidation.isValid && validationStatus.remainingSlots > 0" class="remaining-slots">
            {{ validationStatus.message }}
          </div>
        </div>
        <div v-else class="limit-reached-message error--text">
          {{ validationStatus.message }}
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="btn-tertiary" @click="closeAddProfilePopup">{{ $t('cancel') }}</v-btn>
        <v-btn
          class="btn-primary"
          @click="saveProfile"
          :disabled="!isValid || isLimitReached"
        >{{ $t('save') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { validateSocialMediaLimit, isSocialMediaLimitReached, validateSocialMediaUrl } from '@/utils/socialMediaUtils';

export default {
  name: 'AddProfilePopup',
  props: {
    visiblePopup: {
      type: Boolean,
      required: true,
    },
    currentProfiles: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      profile: '',
    };
  },
  computed: {
    validationStatus() {
      return validateSocialMediaLimit(this.currentProfiles);
    },
    isLimitReached() {
      return isSocialMediaLimitReached(this.currentProfiles);
    },
    urlValidation() {
      return validateSocialMediaUrl(this.profile);
    },
    isValid() {
      return this.profile.trim() && this.urlValidation.isValid;
    },
  },
  methods: {
    closeAddProfilePopup() {
      this.profile = '';
      this.$emit('closeAddProfilePopup');
    },
    // handles backdrop click / ESC — Vuetify emits false via @input
    onDialogInput(val) {
      if (!val) this.closeAddProfilePopup();
    },
    saveProfile() {
      if (this.profile.trim() && !this.isLimitReached && this.urlValidation.isValid) {
        this.$emit('saveAddProfile', [{
          profile: this.profile.trim(),
          platform: this.urlValidation.platform,
        }]);
        this.profile = '';
      }
    },
  },
  watch: {
    visiblePopup(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          if (!this.isLimitReached && this.$refs.profileInput) {
            this.$refs.profileInput.focus();
          }
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';

.remaining-slots {
  margin-top: $space-2;
  font-size: $font-size-sm;
  color: var(--text-secondary);
}

.limit-reached-message {
  margin-top: $space-2;
  font-size: $font-size-base;
}
</style>

<style lang="scss">
@import '~@/assets/styles/design-system';

.add-profile-popup-field {
  .v-label {
    color: var(--text-secondary) !important;
    top: 4px !important;
  }
  &.v-input--is-focused .v-label,
  &.v-input--is-dirty .v-label {
    color: var(--text-secondary) !important;
    top: 4px !important;
  }
  &.error--text .v-label {
    color: var(--severity-critical) !important;
  }
}
</style>
